<template>
  <div class="block">
    <!--    导航栏大小414.4*64-->
    <phone_head />

    <!--    手机轮播图片大小414.4*506.4-->
    <div class="slide_wrapper">
      <el-carousel trigger="click" :autoplay="true">
        <template v-for="(img, i) in imgs">
          <el-carousel-item :key="i">
            <img :src="img.i" alt="" style="width: 100%; height: 100%">
          </el-carousel-item>
        </template>
      </el-carousel>
    </div>
    <!--    主要内容-->
    <div class="title">
      <template v-for="(main, i) in main_data">
        <div :key="i">
          <a v-if="main.u && main.u.indexOf('http:') >= 0" :href="main.u">
            <div class="imgTitle">
              <img :src="main.i" alt="img">
              <div>{{ main.n }}</div>
            </div>
          </a>
          <router-link v-else :to="main.u ? main.u : ''">
            <div class="imgTitle">
              <img :src="main.i" alt="img">
              <div>{{ main.n }}</div>
            </div>
          </router-link>
        </div>
      </template>
    </div>

    <!--页脚-->
    <index_bottom />
  </div>
</template>

<script>
import { get_carousel_data, get_main_data } from '@/api'

export default {
  name: 'PhoneMidde',
  data() {
    return {
      // 是否显示游戏产品等
      isMenu: false,
      isTop: false,
      isMiddle: false,
      isBottom: false,
      isShow: false,
      showTitle: ['游戏产品', '精英招聘', '客服中心', '用户中心', '关于我们'],
      imgs: [],
      main_data: []
    }
  },
  created() {
    get_carousel_data()
      .then(d => {
        const l = d.length
        this.imgs.length = l
        for (let i = 0; i < l; i++) {
          this.imgs.splice(i, 1, d[i])
        }
      })

    get_main_data()
      .then(d => {
        const data = d.d
        const l = data.length
        this.main_data.length = l
        for (let i = 0; i < l; i++) {
          this.main_data.splice(i, 1, data[i])
        }
      })
  },
  methods: {
    // menu按钮点击后显示或者消失
    changeMenu() {
      this.isTop = !this.isTop
      this.isMiddle = !this.isMiddle
      this.isBottom = !this.isBottom
      this.isShow = !this.isShow
      this.isMenu = this.isMenu === false
    }
  }
}
</script>

<style lang="scss" scoped>
.slide_wrapper{
  .el-carousel__container {
    width: 100%;
    height: 506.4PX;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  //轮播图前后按钮设置修改
  .el-carousel__arrow i {
    opacity: 0;
  }

  .el-carousel__arrow {
    border-radius: 0;
    opacity: 0;
    border: 1px none transparent;
    background-color: rgba(0,0,0,0);
  }

  .el-carousel__arrow--left {
    height: 100%;
    width: 10vw;
    left: 0;
  }

  .el-carousel__arrow--right {
    height: 100%;
    width: 10vw;
    right: 0;
  }
}

.title {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-bottom: 60px;

  .imgTitle {
    list-style: none;
    margin: 50px 50px 0;

    img{
      width: 100%;
      height: 250PX;
    }

    div {
      text-align: center;
      font-weight: 500;
      font-size: 50px;
    }
  }
}
</style>
